import script from "./SideHistoryAttendanceChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SideHistoryAttendanceChat.vue?vue&type=script&setup=true&lang=js"

import "./SideHistoryAttendanceChat.vue?vue&type=style&index=0&id=4a2568ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2568ee"]])

export default __exports__
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerHourglass,QIcon,QDialog,QCard,QToolbar,QBtn,QCardSection,QChatMessage,QInput,QField,QRadio,QList,QExpansionItem,QItemSection,QAvatar,QItemLabel,QSeparator,QCardActions,QItem});qInstall(script, 'directives', {ClosePopup,Ripple});
